import { push } from "connected-react-router";
import {
  Header,
  NavigationLinkButton,
  Paragraph,
} from "../../components/RegularComponents";
import { useDispatch, useSelector } from "react-redux";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";
import { 
  ROUTE_PATH, 
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE
} from "../../app/constants";
import { replaceUrlParams } from "../../app/utils";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { removeAgentApplication } from "../../redux/slice/additionalApplicationsSlice";

export const NotResidentCanada = (props) => {

  const agentApplication = useSelector(currentAgentApplicationSelector);
  const licencingSubType = agentApplication ? agentApplication.licencingSubType : LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION
  const isPrincipalBroker = licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;

  const title = isPrincipalBroker ? 
    "Choose a new principal broker" :
    "Mortgage brokers and associate mortgage brokers must be residents of Canada";

  const dispatch = useDispatch();
  return (
    <>
      <div className={"container"}>
        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Header
              style={{ paddingBottom: "30px" }}
              id="not-resident-canada-header"
              header={title}
            />
          </div>
        </div>

        {isPrincipalBroker && (<div className="row">
          <div className="col-xs-12 col-lg-9">
            <Paragraph 
              id="not-resident-canada-text"
              text={[
                "The principal broker for your brokerage must be a resident of Canada.",
                "Choose a new principal broker for your company."
              ]}
            />
          </div>
        </div>)}

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <NavigationLinkButton
              id={"back-to-home-page-link"}
              text={!isPrincipalBroker ? "Back to home page" : "Back to start"}
              onClick={() => {
                // reset current agent application
                if(!isPrincipalBroker && agentApplication?.id) { 
                  // set the current application change type as "DELETE"
                  dispatch(removeAgentApplication(agentApplication.id));

                  dispatch(saveBusinessLicenceApplicationData(
                    APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE, APPLICATION_MODE_NEW))
                    .then(data => {
                      const nextPath = replaceUrlParams(ROUTE_PATH.WELCOME,
                                    APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, 
                                    APPLICATION_MODE_NEW)
                      dispatch(push(`${nextPath}`))
                    })
                } else { 
                  window.location.assign(ROUTE_PATH.LAUNCHPAGE_MORTGAGE)
                }
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
